import React from 'react';
import { Database, RefreshCw, Brain, Eye } from 'lucide-react';
import { spineFeatures } from '../../data/mock';

const iconMap = {
  0: Database,
  1: RefreshCw,
  2: Brain,
  3: Eye,
};

const SpineSection = () => {
  return (
    <section id="about" className="relative py-24 lg:py-32 bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Visual */}
          <div className="relative">
            {/* Spine Illustration - Cleaner Design */}
            <div className="relative">
              {/* Central Spine Line */}
              <div className="absolute left-1/2 top-0 bottom-0 w-px bg-slate-200 dark:bg-slate-700 transform -translate-x-1/2" />
              
              {/* Connection Points */}
              <div className="space-y-5 py-4">
                {['Trade Execution', 'Logistics', 'Inventory', 'Processing', 'Operations', 'Finance', 'Accounting', 'Sustainability', 'Neobank Services'].map((item, index) => (
                  <div
                    key={item}
                    className={`flex items-center gap-4 ${
                      index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                    }`}
                  >
                    <div
                      className={`flex-1 p-4 rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 ${
                        index % 2 === 0 ? 'text-right' : 'text-left'
                      }`}
                    >
                      <span className="font-medium text-slate-700 dark:text-slate-300 text-sm">{item}</span>
                    </div>
                    
                    {/* Connection Dot */}
                    <div className="relative z-10">
                      <div className="w-3 h-3 rounded-full bg-orange-500" />
                    </div>
                    
                    <div className="flex-1" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 dark:text-white leading-tight">
                One Core. <span className="text-orange-500">Everything Connected.</span>
              </h2>
              <p className="mt-6 text-lg text-slate-600 dark:text-slate-400 leading-relaxed">
                TradeEngine.AI acts as an intelligence layer across existing enterprise systems — 
                enabling organic digital transformation without ripping out existing processes.
              </p>
            </div>

            {/* Spine Features */}
            <div className="grid sm:grid-cols-2 gap-4">
              {spineFeatures.map((feature, index) => {
                const Icon = iconMap[index];
                return (
                  <div
                    key={feature.id}
                    className="p-5 rounded-lg bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800"
                  >
                    <div className="w-9 h-9 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center mb-3">
                      <Icon className="w-4 h-4 text-slate-600 dark:text-slate-400" />
                    </div>
                    <h4 className="font-semibold text-slate-900 dark:text-white mb-2 text-sm">{feature.title}</h4>
                    <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpineSection;
